"use client";

import NavLink from "@/components/common/navbar/components/navlink";
import Notifications from "@/components/common/navbar/components/notifications";
import UserMenu from "@/components/common/navbar/menus/user-menu";
import SignupButton from "@/components/shared/signup-button";
import { formatImageUrl } from "@/lib/utils";
import { useAuth } from "@/providers/auth-provider";
import { useCommunityContext } from "@/providers/community-provider";
import { SlashIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import CommunitiesMenu from "./communities-menu";

const CommunitiesHeader = () => {
	const { isLoggedIn, user } = useAuth();
	const { communityInfo, isPublic } = useCommunityContext();
	const communitySlug = communityInfo?.slug;

	const avatarUrl = formatImageUrl(user?.image);

	const isCommunityPage = !isPublic && communitySlug;

	const navLinks = isCommunityPage
		? [
				{
					title: "Home",
					href: `/communities/${communityInfo?.slug}/home`,
					disabled:
						communitySlug === "proptech-india" ||
						communitySlug === "proptech-uae" ||
						communitySlug === "proptech-austria" ||
						communitySlug === "proptech-germany" ||
						communitySlug === "proptech-bangladesh" ||
						communitySlug === "bim-digital-twin" ||
						communitySlug === "global-proptech-founders" ||
						communitySlug === "latam" ||
						communitySlug === "brokers-agents"
							? false
							: true,
				},
				{
					title: "Products",
					href: `/communities/${communityInfo?.slug}/products`,
					disabled:
						communitySlug === "proptech-india" ||
						communitySlug === "proptech-uae" ||
						communitySlug === "proptech-austria" ||
						communitySlug === "proptech-germany" ||
						communitySlug === "proptech-bangladesh" ||
						communitySlug === "latam"
							? false
							: true,
				},
				{ title: "Communities", href: `/communities/${communityInfo?.slug}` },
				{
					title: "Calendar",
					href: `/communities/${communityInfo?.slug}/calendar`,
					disabled: false,
				},
				{
					title: "BIM Vendors",
					href: `/communities/${communityInfo?.slug}/bim`,
					disabled: communitySlug === "bim-digital-twin" ? false : true,
				},
				{
					title: "Job Board",
					href: `/communities/${communityInfo?.slug}/job-board`,
					disabled:
						communitySlug === "proptech-india" ||
						communitySlug === "proptech-austria" ||
						communitySlug === "proptech-germany" ||
						communitySlug === "proptech-bangladesh" ||
						communitySlug === "latam"
							? false
							: true,
				},
				{
					title: "VC",
					href: `/communities/${communityInfo?.slug}/vc`,
					disabled:
						communitySlug === "proptech-india" ||
						communitySlug === "proptech-austria" ||
						communitySlug === "proptech-germany"
							? false
							: true,
				},
				{ title: "Courses", href: "#", disabled: true },
				{ title: "Leaderboards", href: "#", disabled: true },
				{
					title: "Tickets",
					href: `/communities/${communityInfo?.slug}/tickets`,
					disabled: communitySlug === "africa-valuation-conference" ? false : true,
				},
		  ]
		: [
				{ title: "Leaders Hive", href: "/leaderboard" },
				{ title: "Categories", href: "/categories" },
				{ title: "Discover Communities", href: "/communities" },
				{ title: "Global Feed", href: "/communities/feed" },
				{ title: "Services", href: "/marketing" },
		  ];

	return (
		<header className="h-14 bg-white px-4 py-2 shadow-sm">
			<nav className="flex items-center gap-4">
				<div className="flex items-center gap-px">
					<Link href="/">
						<Image
							src="/images/default-placeholder-image.png"
							className="h-10 w-10 rounded-lg"
							alt="PropTechBuzz Logo"
							width={480}
							height={480}
						/>
					</Link>

					<SlashIcon className="h-4 w-4 rotate-[-20deg] text-gray-300" />

					<CommunitiesMenu
						name={communityInfo && "name" in communityInfo ? communityInfo.name : undefined}
						logo={communityInfo && "logo" in communityInfo ? communityInfo.logo : undefined}
					/>
				</div>

				<div className="hidden items-center gap-6 md:flex">
					{navLinks.map(
						({ title, href, disabled }, index) =>
							!disabled && (
								<NavLink key={index} title={title} href={href} className="whitespace-nowrap" />
							)
					)}
				</div>

				<div className="ml-auto flex items-center gap-4">
					{isLoggedIn ? (
						<>
							<Notifications />
							<UserMenu
								username={user?.username || ""}
								show
								isVerified={user?.isVerified || false}
								isFounder={user?.isFounder || false}
								profileImageUrl={avatarUrl}
							/>
						</>
					) : (
						<SignupButton size="md" />
					)}
				</div>
			</nav>
		</header>
	);
};

export default CommunitiesHeader;
